import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { canonicalUrl } from '../../config/siteConfig';

/**
 * SINGLE SOURCE OF TRUTH for the site-wide canonical tag.
 *
 * - Base URL comes from the single validated config (config/siteConfig.js →
 *   REACT_APP_SITE_URL, forced to the production host).
 * - Canonicals are ALWAYS self-referencing on the production host.
 * - Path is derived from react-router's location (pathname only) — NEVER
 *   window.location.origin, the request host or the preview/deployment URL.
 * NOTE: the meta description is owned by <SEOHead/> (page components are the
 * single source of truth), not here.
 */
export const AutoCanonical = () => {
  const { pathname } = useLocation();
  const href = canonicalUrl(pathname);

  return (
    <Helmet>
      <link rel="canonical" href={href} />
      <meta property="og:url" content={href} />
      <meta name="twitter:url" content={href} />
    </Helmet>
  );
};

export default AutoCanonical;
